import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import { DEFAULT_PAGE_TITLE } from '../lib/siteMeta';

const NotFoundPage: React.FC = () => {
  useEffect(() => {
    document.title = '404 - Page Not Found | Rankum';
    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <Header />
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md text-center animate-fade-in">
        <h1 className="font-display text-6xl md:text-8xl text-amber mb-4">404</h1>
        <h2 className="font-display text-2xl md:text-3xl text-charcoal mb-4">
          Page Not Found
        </h2>
        <p className="text-charcoal-light mb-8 leading-relaxed">
          Looks like this page doesn't exist. Maybe it's off exploring new restaurants?
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn-primary">
            <span>View All Restaurants</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
          <Link
            to="/recommenders"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-charcoal/20 text-charcoal hover:border-amber hover:text-amber transition-colors duration-300"
          >
            <span>Meet Our Recommenders</span>
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
